/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import ConsumptionBreakDownCard, {
  Unit
} from '@nile/reports/src/modules/RetinerReport/components/cards/ConsumptionBreakDownCard';
import { AccountClient, GET_RETAINER_UTILIZATION } from '@nile/graphql';
import { FormattedMessage } from 'react-intl';

interface ConsumptionBreakdownCardData {
  title: string;
  icon: string;
  accessor: string;
}

type Accessor = 'totalAllotted' | 'consumed' | 'remaining' | 'utilization';

function ConsumptionBreakdownCards({
  data,
  loading
}: {
  data: ConsumptionBreakdownData;
  loading: boolean;
}) {
  const isBlockMoney = data?.offeringType === 'BLOCK_MONEY';

  const cardsData: ConsumptionBreakdownCardData[] = [
    {
      title: 'common.label.totalAllotted',
      icon: isBlockMoney ? 'BillableColor' : 'ChartModule',
      accessor: 'totalAllotted'
    },
    {
      title: 'common.label.consumed',
      icon: isBlockMoney ? 'BillableColor' : 'ChartModule',
      accessor: 'consumed'
    },
    {
      title: 'common.label.remaining',
      icon: isBlockMoney ? 'BillableColor' : 'ChartModule',
      accessor: 'remaining'
    },
    {
      title: 'common.label.utilization',
      icon: isBlockMoney ? 'BillableColor' : 'ChartModule',
      accessor: 'utilization'
    }
  ];

  const unitMap: Record<Accessor, Unit> = {
    utilization: 'percentage',
    totalAllotted: isBlockMoney ? 'money' : 'hours',
    consumed: isBlockMoney ? 'money' : 'hours',
    remaining: isBlockMoney ? 'money' : 'hours'
  };

  return (
    <div className="flex gap-20">
      {cardsData?.map((el: ConsumptionBreakdownCardData) => {
        const unit: Unit = unitMap[el.accessor as Accessor];
        const icon: string = isBlockMoney
          ? 'BillableColor'
          : 'AfterHoursGradient';
        return (
          <ConsumptionBreakDownCard
            key={el.title}
            title={el.title}
            icon={icon}
            value={data[el.accessor as Accessor]}
            unit={unit}
            loading={loading}
          />
        );
      })}
    </div>
  );
}

interface ConsumptionBreakdownData {
  contractName: string;
  client: {
    name: string;
    accountId: string;
  };
  offeringType: string;
  totalAllotted: string;
  consumed: string;
  remaining: string;
  utilization: string;
}

const ConsumptionBreakdownChart = ({
  clientId,
  contractId,
  sharedReport,
  reportId
}: {
  clientId: string;
  contractId?: string;
  sharedReport: boolean;
  reportId: string;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  // const data: ConsumptionBreakdownData[] = [
  //   {
  //     contractName: 'Contract 1',
  //     client: {
  //       name: 'Client 1',
  //       accountId: '123'
  //     },
  //     offeringType: 'Block Money',
  //     totalAllotted: '100',
  //     consumed: '100',
  //     remaining: '0',
  //     utilization: '100'
  //   },
  //   {
  //     contractName: 'Contract 2',
  //     client: {
  //       name: 'Client 2',
  //       accountId: '456'
  //     },
  //     offeringType: 'Block Hours',
  //     totalAllotted: '100',
  //     consumed: '100',
  //     remaining: '0',
  //     utilization: '100'
  //   }
  // ];
  const [data, setData] = useState<ConsumptionBreakdownData[]>([]);

  useEffect(() => {
    setLoading(true);
    AccountClient.query({
      query: GET_RETAINER_UTILIZATION,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          client: { accountId: clientId },
          ...(contractId && { contract: { contractId: contractId } }),
          ...(sharedReport && reportId && { sharedReportId: reportId })
        }
      }
    })
      .then((response: any) => {
        setData(response.data.getRetainerUtilization);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [clientId, contractId]);

  const oferringTypeKeys = {
    BLOCK_MONEY: {
      defaultMessage: 'Block Money Overview',
      id: 'common.label.blockMoneyOverview'
    },
    BLOCK_HOUR: {
      defaultMessage: 'Block Hour Overview',
      id: 'common.label.blockHourOverview'
    }
  };

  return (
    <div className="grid gap-20 scroll">
      {data?.map((el: ConsumptionBreakdownData) => {
        return (
          <div key={el.contractName}>
            <div className="f-16 bold mb-10">
              <FormattedMessage
                {...oferringTypeKeys[
                  el.offeringType as keyof typeof oferringTypeKeys
                ]}
              />
            </div>
            <ConsumptionBreakdownCards data={el} loading={loading} />
          </div>
        );
      })}
    </div>
  );
};

export default ConsumptionBreakdownChart;
